import { render } from "./teaStudioState.vue?vue&type=template&id=204858ee&scoped=true"
import script from "./teaStudioState.vue?vue&type=script&lang=js"
export * from "./teaStudioState.vue?vue&type=script&lang=js"

import "./teaStudioState.vue?vue&type=style&index=0&id=204858ee&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204858ee"]])

export default __exports__